
import DashboardLayout from '../pages/Dashboard/Layout/DashboardLayout'

// FINANCE
const financeUserAreas = () => import('@/pages/Finance/linkUsersAreas/index')
const accountConfig = () => import('@/pages/Finance/accountConfig/index')
const expensesCheck = () => import('@/pages/Finance/expensesCheck/index')
const fixedFunds = () => import('@/pages/Finance/fixedFunds/index')
const expensesRequest = () => import('@/pages/Finance/expensesRequest/index')

const finance = {
  path: '/',
  component: DashboardLayout,
  name: 'Finance',
  title: 'Finanzas',
  icon: 'attach_money',
  // roles: ['ADM', 'GEFI', 'ATES'],
  excludedGroups: [ 'Extranet' ],
  excludedGroups: [ 'Extranet' ],
  excludedRoles: [ 'IDEAL' ],
  children: [
    {
      path: '/finanzas/usuario-areas',
      name: 'Usuarios Areas',
      title: 'Usuarios Áreas',
      component: financeUserAreas,
      meta: {
        ifUserCan: {
          change: 'Users/userarea'
        }
      },
      // roles: ['ADM', 'GEFI', 'ATES'],
    },
    {
      path: '/finanzas/configuracion-cuentas',
      name: 'Configuración de cuentas',
      title: 'Configuración de cuentas',
      meta: {
        ifUserCan: {
          view: 'accounting_account/accountandeventsettings'
        }
      },
      component: accountConfig,
      // roles: ['ADM', 'GEFI', 'ATES'],
    },
    {
      path: '/finanzas/fondo_fijo',
      name: 'Fondo fijo',
      title: 'Fondo fijo',
      component: fixedFunds,
      meta: {
        ifUserCan: {
          view: 'accounting_account/accountingaccountsbalance'
        }
      },
      // roles: ['ADM', 'GEFI', 'ATES'],
    },
    {
      path: '/solicitud_de_gastos',
      name: 'Solicitud de gastos',
      title: 'Solicitud de gastos',
      component: expensesRequest,
      meta: {
        ifUserCan: {
          add: 'Users/provisionforuserexpenses'
        }
      },
    },
    // {
    //   path: '/comprobación_de_gastos',
    //   name: 'Comprobación de gastos',
    //   title: 'Comprobación de gastos',
    //   component: expensesCheck,
    //   meta: {
    //     ifUserCan: {
    //       view: 'Users/provisionforuserexpenses'
    //     }
    //   },
    // },
  ],
}

export default finance



// WEBPACK FOOTER //
// ./src/router/financeRoutes.js